
export default {
    name: 'AutoQuoteForm',
    props: {
        autoQuotes: {
            type: Array,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
        isEditForm: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        grabBagSizes() {
            return this.autoQuotes.find((autoQuote) => autoQuote.service_id === 3).prices;
        },
        skipSizes() {
            return this.autoQuotes.find((autoQuote) => autoQuote.service_id === 2).prices;
        },
    },
};
